import * as React from 'react';
export const IcPercentageDecrease = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.996 9.001a2.994 2.994 0 002.769-1.852 3.004 3.004 0 00-2.184-4.09 2.993 2.993 0 00-3.076 1.275 3.003 3.003 0 002.491 4.667zm10.987 6a2.994 2.994 0 00-2.768 1.852 3.004 3.004 0 00.65 3.27A2.994 2.994 0 0020.978 18a3.002 3.002 0 00-2.996-3zm-12.984 6h3.995a.998.998 0 00.706-1.707.998.998 0 00-.706-.293H7.306L20.71 4.681a1 1 0 000-1.41.999.999 0 00-.73-.27.998.998 0 00-.729.32L5.998 17.471v-1.47a1 1 0 00-1-1 .998.998 0 00-.998 1v4a1 1 0 00.999 1z'
      fill='currentColor'
    />
  </svg>
);
